export default __webpack_public_path__ + "static/media/LEVEL10.c845c2e6.png";